import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/HomePage.vue";
console.log(Home)

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    }
];

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
});

export default router;
